import './reviews-rating.css'

const selectors = {
  MEDIA_FILTER: '.yotpo-media-select',
  PAGE_HEADER: '.js-page-header',
  REVIEWS_WIDGET: '#yotpo-reviews-main-widget',
  STAR_RATING: '.yotpo-widget-instance',
  VIEW_PHOTOS: '[data-review-photos]'
}

const HIDDEN_CLASS = 'hidden'

class ReviewsRating extends HTMLElement {
  constructor() {
    super()
    this.handleStarRatingClick = this.handleStarRatingClick.bind(this)
    this.handleViewPhotosClick = this.handleViewPhotosClick.bind(this)
  }

  connectedCallback() {
    this.starRating = this.querySelector(selectors.STAR_RATING)
    this.viewPhotosButton = this.querySelector(selectors.VIEW_PHOTOS)

    this.starRating?.addEventListener('click', this.handleStarRatingClick)

    if (this.viewPhotosButton) this.observeReviews()
  }

  disconnectedCallback() {
    this.reviewsObserver?.disconnect()
    this.starRating?.removeEventListener('click', this.handleStarRatingClick)
    this.viewPhotosButton?.removeEventListener('click', this.handleViewPhotosClick)
  }

  /**
   * Yotpo renders the review widget after page load, and on small screens it
   * moves the filters into a popup at the end of the body, so the whole
   * document is watched rather than the widget's own section.
   */
  observeReviews() {
    if (this.revealViewPhotos()) return

    this.reviewsObserver = new MutationObserver(() => {
      if (this.revealViewPhotos()) this.reviewsObserver.disconnect()
    })

    this.reviewsObserver.observe(document.body, { childList: true, subtree: true })
  }

  revealViewPhotos() {
    if (!document.querySelector(selectors.MEDIA_FILTER)) return false

    this.viewPhotosButton.classList.remove(HIDDEN_CLASS)
    this.viewPhotosButton.addEventListener('click', this.handleViewPhotosClick)

    return true
  }

  handleStarRatingClick(event) {
    event.stopPropagation()
    this.scrollToReviews()
  }

  handleViewPhotosClick(event) {
    event.stopPropagation()
    this.scrollToReviews()

    const mediaFilter = document.querySelector(selectors.MEDIA_FILTER)

    if (mediaFilter && mediaFilter.getAttribute('aria-pressed') !== 'true') {
      mediaFilter.click()
    }
  }

  /**
   * The header is fixed and slides its top bar out of view once the page is
   * scrolled, so only the height that is left over covers the review widget.
   */
  getHeaderOffset() {
    const header = document.querySelector(selectors.PAGE_HEADER)
    if (!header) return 0

    const topBarHeight = parseFloat(window.getComputedStyle(header).getPropertyValue('--topbar-height')) || 0

    return Math.max(header.offsetHeight - topBarHeight, 0)
  }

  scrollToReviews() {
    const widget = document.querySelector(selectors.REVIEWS_WIDGET)
    if (!widget) return

    const top = widget.getBoundingClientRect().top + window.scrollY - this.getHeaderOffset()

    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' })
  }
}

if (!customElements.get('reviews-rating')) {
  customElements.define('reviews-rating', ReviewsRating)
}
